import { CurrentUser } from "src/interfaces/user.interface";
import { UserStore } from "src/slices/shared/user/user-interface";

export const initialState: UserStore = {
  jwt: "",
  isLoading: false,
  loggedInUser: <CurrentUser>{},
};
